import { Baby } from "../requests";
import EditBabyForm from './EditBabyForm';
import { useNavigate, useLocation } from "react-router-dom";

const EditBabyPage = (props) => {

  const navigate = useNavigate()
  const location = useLocation()
  const fromBabyDetails = location.state

  // console.log(props);

  const updateBaby = (id, params) => {
    Baby.update(id, params).then((b) => {
      navigate(`/clients/${b.client_id}`)
    })
  }
  return (
    <>
      <div>
        <h1 className="text-center">Edit client page</h1>
        <EditBabyForm
          updateBaby={updateBaby}
          id={fromBabyDetails.fromBabyDetails.id}
          name={fromBabyDetails.fromBabyDetails.name}
          date_of_birth={fromBabyDetails.fromBabyDetails.date_of_birth}
          diapers={fromBabyDetails.fromBabyDetails.diapers}
          formula={fromBabyDetails.fromBabyDetails.formula}
          formula_type={fromBabyDetails.fromBabyDetails.formula_type}
          formula_amount={fromBabyDetails.fromBabyDetails.formula_amount}
        />
      </div>
    </>
  )
}

export default EditBabyPage